var map = {
	"./symbol_0.png": 56128,
	"./symbol_1.png": 82986,
	"./symbol_10.png": 90032,
	"./symbol_11.png": 86937,
	"./symbol_12.png": 38754,
	"./symbol_13.png": 59883,
	"./symbol_14.png": 13972,
	"./symbol_15.png": 35101,
	"./symbol_16.png": 93862,
	"./symbol_17.png": 32879,
	"./symbol_2.png": 31969,
	"./symbol_3.png": 20523,
	"./symbol_4.png": 22519,
	"./symbol_5.png": 48878,
	"./symbol_6.png": 51301,
	"./symbol_7.png": 11407,
	"./symbol_8.png": 14091,
	"./symbol_9.png": 50434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85718;